import { IconAdd } from './Add';
import { IconArrowDown } from './ArrowDown';
import { IconArrowUp } from './ArrowUp';
import { IconCheck } from './Check';
import { IconChevronLeft } from './ChevronLeft';
import { IconChevronRight } from './ChevronRight';
import { IconCross } from './Cross';
import { IconInfo } from './Info';
import { IconQuestionmark } from './Questionmark';
import { IconPendingOne } from './PendingOne';
import { IconPendingTwo } from './PendingTwo';
import { IconPendingThree } from './PendingThree';
export const IconCircle = {
    CircleAdd: IconAdd,
    CircleArrowDown: IconArrowDown,
    CircleArrowUp: IconArrowUp,
    CircleCheck: IconCheck,
    CircleCross: IconCross,
    CircleInfo: IconInfo,
    CircleQuestionmark: IconQuestionmark,
    CirclePendingOne: IconPendingOne,
    CirclePendingTwo: IconPendingTwo,
    CirclePendingThree: IconPendingThree,
    CircleChevronLeft: IconChevronLeft,
    CircleChevronRight: IconChevronRight,
};
//# sourceMappingURL=index.js.map